import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/fa497301-2950-4499-a8a8-695936a877f0_compressed_IMG_0355.webp"
          alt="Алексей Сивко — тренинг для руководителей"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="max-w-3xl">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-3 leading-tight">
              Тренинг для руководителей
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-teal-300 mb-5 leading-snug">
              Руководитель определяет результат всей команды
            </p>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed">
              Развиваем руководителей, которые умеют не только ставить задачи, но и вдохновлять команду, принимать сильные решения, управлять изменениями и достигать бизнес-результатов.
            </p>

            {/* Кнопки */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Заказать тренинг для руководителей
                <i className="ri-arrow-right-line"></i>
              </button>
              <LeadMagnetHeroTeaser />
            </div>
            <p className="text-white/50 text-xs mt-3">
              Если сильный специалист вырос в руководителя — тренинг помогает перейти от «делаю сам» к управлению командой.
            </p>
          </div>


        </div>
      </div>
    </section>
  );
}